import { createSlice } from '@reduxjs/toolkit';

/* ----------------------------------------------------------------
      SLICE (ACTIONS/REDUCERS)
---------------------------------------------------------------- */

const initialState = {
  topMenuOpen: false,
  bottomMenuOpen: false,
  sideMenuOpen: true,
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    toggleTopMenu(state) {
      state.topMenuOpen = !state.topMenuOpen;
      state.bottomMenuOpen = false;
    },
    toggleBottomMenu(state) {
      state.bottomMenuOpen = !state.bottomMenuOpen;
      state.topMenuOpen = false;
    },
    closeTopMenu(state) {
      state.topMenuOpen = false;
    },
    toggleSideMenu(state) {
      state.sideMenuOpen = !state.sideMenuOpen;
    },
  },
});

export const { toggleTopMenu, toggleBottomMenu, closeTopMenu, toggleSideMenu } = menuSlice.actions;
export default menuSlice.reducer;
